module.exports = __webpack_public_path__ + "static/pillar-of-hope-e3bfc2f8734ebc0cdab501a1b9b15362.jpg";